import { useState } from "react"

type LinkModalProps = {

    show: boolean,
    link: string,

    onClose: () => void
}

const LinkModal = ({ show, link, onClose } : LinkModalProps) => {

    const [copied, setCopied] = useState<boolean>(false);

    /**
     * Function writes link to clipboard.
     */
    const onCopyButtonClick = () => {
        /* Write Link to Clipboard */
        navigator.clipboard.writeText(link);
        setCopied(true);
    }

    return (
        <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
            <div className="modal-dialog modal-lg">

                <div className="modal-content">

                    <div className="modal-header">
                        <button className="btn-close" onClick={onClose} />
                    </div>

                    <div className="modal-body">

                        <div className="row">

                            <div className="col-12 input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-link"></i>
                                </span>
                                <input type="text" className="form-control" disabled={true} value={link} />
                                {
                                    copied ? <button className="btn btn-success fw-bold"><i className="bi bi-hand-thumbs-up me-1" />Link Copied</button>
                                           : <button className="btn btn-primary fw-bold" onClick={onCopyButtonClick}><i className="bi bi-clipboard me-1" />To Clipboard</button>
                                }
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    )

}
export default LinkModal;